var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.comments),function(comment,index){return _c('Comment',{key:index,attrs:{"collection":_vm.collection,"comment":comment,"level":_vm.level + 1},on:{"posted":function($event){return _vm.$emit('posted')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }